import { emptySplitApi as api } from './emptyApi';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    campaignServiceListCampaigns: build.query<
      CampaignServiceListCampaignsApiResponse,
      CampaignServiceListCampaignsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask
        }
      })
    }),
    campaignServiceCreateCampaign: build.mutation<
      CampaignServiceCreateCampaignApiResponse,
      CampaignServiceCreateCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1Campaign
      })
    }),
    campaignServiceGetCampaign: build.query<
      CampaignServiceGetCampaignApiResponse,
      CampaignServiceGetCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns/${queryArg.campaign}`,
        params: { read_mask: queryArg.readMask }
      })
    }),
    campaignServiceDeleteCampaign: build.mutation<
      CampaignServiceDeleteCampaignApiResponse,
      CampaignServiceDeleteCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns/${queryArg.campaign}`,
        method: 'DELETE'
      })
    }),
    campaignServiceUpdateCampaign: build.mutation<
      CampaignServiceUpdateCampaignApiResponse,
      CampaignServiceUpdateCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns/${queryArg.campaign}`,
        method: 'PATCH',
        body: queryArg.factoryEmaillabApiV1Campaign,
        params: { update_mask: queryArg.updateMask }
      })
    }),
    campaignServiceHarddeleteCampaign: build.mutation<
      CampaignServiceHarddeleteCampaignApiResponse,
      CampaignServiceHarddeleteCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns/${queryArg.campaign}:harddelete`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1HarddeleteCampaignRequest
      })
    }),
    campaignServiceUndeleteCampaign: build.mutation<
      CampaignServiceUndeleteCampaignApiResponse,
      CampaignServiceUndeleteCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns/${queryArg.campaign}:undelete`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1UndeleteCampaignRequest
      })
    }),
    campaignServiceBatchCreateCampaigns: build.mutation<
      CampaignServiceBatchCreateCampaignsApiResponse,
      CampaignServiceBatchCreateCampaignsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns:batchCreate`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1BatchCreateCampaignsRequest
      })
    }),
    campaignServiceBatchGetCampaigns: build.query<
      CampaignServiceBatchGetCampaignsApiResponse,
      CampaignServiceBatchGetCampaignsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask }
      })
    }),
    campaignServiceBatchUpdateCampaigns: build.mutation<
      CampaignServiceBatchUpdateCampaignsApiResponse,
      CampaignServiceBatchUpdateCampaignsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns:batchUpdate`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1BatchUpdateCampaignsRequest
      })
    }),
    campaignServiceSyncCampaign: build.mutation<
      CampaignServiceSyncCampaignApiResponse,
      CampaignServiceSyncCampaignApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/campaigns:sync`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1SyncCampaignRequest
      })
    }),
    folderServiceListFolders: build.query<
      FolderServiceListFoldersApiResponse,
      FolderServiceListFoldersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/folders`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask
        }
      })
    }),
    folderServiceCreateFolder: build.mutation<
      FolderServiceCreateFolderApiResponse,
      FolderServiceCreateFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/folders`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1Folder
      })
    }),
    folderServiceGetFolder: build.query<
      FolderServiceGetFolderApiResponse,
      FolderServiceGetFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/folders/${queryArg.folder}`,
        params: { read_mask: queryArg.readMask }
      })
    }),
    folderServiceDeleteFolder: build.mutation<
      FolderServiceDeleteFolderApiResponse,
      FolderServiceDeleteFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/folders/${queryArg.folder}`,
        method: 'DELETE'
      })
    }),
    folderServiceUpdateFolder: build.mutation<
      FolderServiceUpdateFolderApiResponse,
      FolderServiceUpdateFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/folders/${queryArg.folder}`,
        method: 'PATCH',
        body: queryArg.factoryEmaillabApiV1Folder,
        params: { update_mask: queryArg.updateMask }
      })
    }),
    folderServiceHarddeleteFolder: build.mutation<
      FolderServiceHarddeleteFolderApiResponse,
      FolderServiceHarddeleteFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/folders/${queryArg.folder}:harddelete`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1HarddeleteFolderRequest
      })
    }),
    folderServiceUndeleteFolder: build.mutation<
      FolderServiceUndeleteFolderApiResponse,
      FolderServiceUndeleteFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/folders/${queryArg.folder}:undelete`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1UndeleteFolderRequest
      })
    }),
    folderServiceBatchCreateFolders: build.mutation<
      FolderServiceBatchCreateFoldersApiResponse,
      FolderServiceBatchCreateFoldersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/folders:batchCreate`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1BatchCreateFoldersRequest
      })
    }),
    folderServiceBatchGetFolders: build.query<
      FolderServiceBatchGetFoldersApiResponse,
      FolderServiceBatchGetFoldersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/folders:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask }
      })
    }),
    folderServiceBatchUpdateFolders: build.mutation<
      FolderServiceBatchUpdateFoldersApiResponse,
      FolderServiceBatchUpdateFoldersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/folders:batchUpdate`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1BatchUpdateFoldersRequest
      })
    }),
    authServiceLoginTenant: build.query<
      AuthServiceLoginTenantApiResponse,
      AuthServiceLoginTenantApiArg
    >({
      query: () => ({ url: `/v1/oauth:loginTenant` })
    }),
    authServiceLogoutTenant: build.query<
      AuthServiceLogoutTenantApiResponse,
      AuthServiceLogoutTenantApiArg
    >({
      query: () => ({ url: `/v1/oauth:logoutTenant` })
    }),
    authServiceTokenTenant: build.query<
      AuthServiceTokenTenantApiResponse,
      AuthServiceTokenTenantApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/oauth:tokenTenant`,
        params: {
          code: queryArg.code,
          state: queryArg.state,
          client_id: queryArg.clientId,
          client_secret: queryArg.clientSecret,
          account_id: queryArg.accountId
        }
      })
    }),
    oauthstateServiceListOauthstates: build.query<
      OauthstateServiceListOauthstatesApiResponse,
      OauthstateServiceListOauthstatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/oauthstates`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask
        }
      })
    }),
    oauthstateServiceCreateOauthstate: build.mutation<
      OauthstateServiceCreateOauthstateApiResponse,
      OauthstateServiceCreateOauthstateApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/oauthstates`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1Oauthstate
      })
    }),
    oauthstateServiceGetOauthstate: build.query<
      OauthstateServiceGetOauthstateApiResponse,
      OauthstateServiceGetOauthstateApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/oauthstates/${queryArg.oauthstate}`,
        params: { read_mask: queryArg.readMask }
      })
    }),
    authServiceListOauthtokens: build.query<
      AuthServiceListOauthtokensApiResponse,
      AuthServiceListOauthtokensApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/oauthtokens`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask
        }
      })
    }),
    authServiceCreateOauthtoken: build.mutation<
      AuthServiceCreateOauthtokenApiResponse,
      AuthServiceCreateOauthtokenApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/oauthtokens`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1Oauthtoken
      })
    }),
    authServiceGetOauthtoken: build.query<
      AuthServiceGetOauthtokenApiResponse,
      AuthServiceGetOauthtokenApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/oauthtokens/${queryArg.oauthtoken}`,
        params: { read_mask: queryArg.readMask }
      })
    }),
    authServiceUpdateOauthtoken: build.mutation<
      AuthServiceUpdateOauthtokenApiResponse,
      AuthServiceUpdateOauthtokenApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/oauthtokens/${queryArg.oauthtoken}`,
        method: 'PATCH',
        body: queryArg.factoryEmaillabApiV1Oauthtoken,
        params: { update_mask: queryArg.updateMask }
      })
    }),
    authServiceHarddeleteOauthtoken: build.mutation<
      AuthServiceHarddeleteOauthtokenApiResponse,
      AuthServiceHarddeleteOauthtokenApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/oauthtokens/${queryArg.oauthtoken}:harddelete`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1HarddeleteOauthtokenRequest
      })
    }),
    projectServiceListProjects: build.query<
      ProjectServiceListProjectsApiResponse,
      ProjectServiceListProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/projects`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask
        }
      })
    }),
    projectServiceCreateProject: build.mutation<
      ProjectServiceCreateProjectApiResponse,
      ProjectServiceCreateProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/projects`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1Project
      })
    }),
    projectServiceGetProject: build.query<
      ProjectServiceGetProjectApiResponse,
      ProjectServiceGetProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/projects/${queryArg.project}`,
        params: { read_mask: queryArg.readMask }
      })
    }),
    projectServiceDeleteProject: build.mutation<
      ProjectServiceDeleteProjectApiResponse,
      ProjectServiceDeleteProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/projects/${queryArg.project}`,
        method: 'DELETE'
      })
    }),
    projectServiceUpdateProject: build.mutation<
      ProjectServiceUpdateProjectApiResponse,
      ProjectServiceUpdateProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/projects/${queryArg.project}`,
        method: 'PATCH',
        body: queryArg.factoryEmaillabApiV1Project,
        params: { update_mask: queryArg.updateMask }
      })
    }),
    projectServiceHarddeleteProject: build.mutation<
      ProjectServiceHarddeleteProjectApiResponse,
      ProjectServiceHarddeleteProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/projects/${queryArg.project}:harddelete`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1HarddeleteProjectRequest
      })
    }),
    projectServiceUndeleteProject: build.mutation<
      ProjectServiceUndeleteProjectApiResponse,
      ProjectServiceUndeleteProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/projects/${queryArg.project}:undelete`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1UndeleteProjectRequest
      })
    }),
    projectServiceBatchCreateProjects: build.mutation<
      ProjectServiceBatchCreateProjectsApiResponse,
      ProjectServiceBatchCreateProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/projects:batchCreate`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1BatchCreateProjectsRequest
      })
    }),
    projectServiceBatchGetProjects: build.query<
      ProjectServiceBatchGetProjectsApiResponse,
      ProjectServiceBatchGetProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/projects:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask }
      })
    }),
    projectServiceBatchUpdateProjects: build.mutation<
      ProjectServiceBatchUpdateProjectsApiResponse,
      ProjectServiceBatchUpdateProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/projects:batchUpdate`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1BatchUpdateProjectsRequest
      })
    }),
    sfmcFolderServiceListSfmcFolders: build.query<
      SfmcFolderServiceListSfmcFoldersApiResponse,
      SfmcFolderServiceListSfmcFoldersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/sfmcFolders`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask
        }
      })
    }),
    sfmcFolderServiceCreateSfmcFolder: build.mutation<
      SfmcFolderServiceCreateSfmcFolderApiResponse,
      SfmcFolderServiceCreateSfmcFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/sfmcFolders`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1SfmcFolder
      })
    }),
    sfmcFolderServiceGetSfmcFolder: build.query<
      SfmcFolderServiceGetSfmcFolderApiResponse,
      SfmcFolderServiceGetSfmcFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/sfmcFolders/${queryArg.sfmcFolder}`,
        params: { read_mask: queryArg.readMask }
      })
    }),
    sfmcFolderServiceDeleteSfmcFolder: build.mutation<
      SfmcFolderServiceDeleteSfmcFolderApiResponse,
      SfmcFolderServiceDeleteSfmcFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/sfmcFolders/${queryArg.sfmcFolder}`,
        method: 'DELETE'
      })
    }),
    sfmcFolderServiceUpdateSfmcFolder: build.mutation<
      SfmcFolderServiceUpdateSfmcFolderApiResponse,
      SfmcFolderServiceUpdateSfmcFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/sfmcFolders/${queryArg.sfmcFolder}`,
        method: 'PATCH',
        body: queryArg.factoryEmaillabApiV1SfmcFolder,
        params: { update_mask: queryArg.updateMask }
      })
    }),
    sfmcFolderServiceHarddeleteSfmcFolder: build.mutation<
      SfmcFolderServiceHarddeleteSfmcFolderApiResponse,
      SfmcFolderServiceHarddeleteSfmcFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/sfmcFolders/${queryArg.sfmcFolder}:harddelete`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1HarddeleteSfmcFolderRequest
      })
    }),
    sfmcFolderServiceUndeleteSfmcFolder: build.mutation<
      SfmcFolderServiceUndeleteSfmcFolderApiResponse,
      SfmcFolderServiceUndeleteSfmcFolderApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/sfmcFolders/${queryArg.sfmcFolder}:undelete`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1UndeleteSfmcFolderRequest
      })
    }),
    sfmcFolderServiceBatchCreateSfmcFolders: build.mutation<
      SfmcFolderServiceBatchCreateSfmcFoldersApiResponse,
      SfmcFolderServiceBatchCreateSfmcFoldersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/sfmcFolders:batchCreate`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1BatchCreateSfmcFoldersRequest
      })
    }),
    sfmcFolderServiceBatchGetSfmcFolders: build.query<
      SfmcFolderServiceBatchGetSfmcFoldersApiResponse,
      SfmcFolderServiceBatchGetSfmcFoldersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/sfmcFolders:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask }
      })
    }),
    sfmcFolderServiceBatchUpdateSfmcFolders: build.mutation<
      SfmcFolderServiceBatchUpdateSfmcFoldersApiResponse,
      SfmcFolderServiceBatchUpdateSfmcFoldersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/sfmcFolders:batchUpdate`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1BatchUpdateSfmcFoldersRequest
      })
    }),
    userServiceListUsers: build.query<
      UserServiceListUsersApiResponse,
      UserServiceListUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/users`,
        params: {
          page_size: queryArg.pageSize,
          page_number: queryArg.pageNumber,
          filter: queryArg.filter,
          order_by: queryArg.orderBy,
          show_deleted: queryArg.showDeleted,
          read_mask: queryArg.readMask
        }
      })
    }),
    userServiceCreateUser: build.mutation<
      UserServiceCreateUserApiResponse,
      UserServiceCreateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/users`,
        method: 'POST',
        body: queryArg.factoryEmaillabApiV1User
      })
    }),
    userServiceGetUser: build.query<
      UserServiceGetUserApiResponse,
      UserServiceGetUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/users/${queryArg.user}`,
        params: { read_mask: queryArg.readMask }
      })
    }),
    userServiceDeleteUser: build.mutation<
      UserServiceDeleteUserApiResponse,
      UserServiceDeleteUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/users/${queryArg.user}`,
        method: 'DELETE'
      })
    }),
    userServiceUpdateUser: build.mutation<
      UserServiceUpdateUserApiResponse,
      UserServiceUpdateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/users/${queryArg.user}`,
        method: 'PATCH',
        body: queryArg.factoryEmaillabApiV1User,
        params: { update_mask: queryArg.updateMask }
      })
    }),
    userServiceBatchGetUsers: build.query<
      UserServiceBatchGetUsersApiResponse,
      UserServiceBatchGetUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/users:batchGet`,
        params: { names: queryArg.names, read_mask: queryArg.readMask }
      })
    }),
    userServiceSearchUser: build.query<
      UserServiceSearchUserApiResponse,
      UserServiceSearchUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/users:search`,
        params: { key: queryArg.key, value: queryArg.value }
      })
    })
  }),
  overrideExisting: false
});
export { injectedRtkApi as apiGenerated };
export type CampaignServiceListCampaignsApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1ListCampaignsResponse;
export type CampaignServiceListCampaignsApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** Should follow the Filtering best practices defined by Google AIP here https://google.aip.dev/160 */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type CampaignServiceCreateCampaignApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Campaign;
export type CampaignServiceCreateCampaignApiArg = {
  factoryEmaillabApiV1Campaign: FactoryEmaillabApiV1Campaign;
};
export type CampaignServiceGetCampaignApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Campaign;
export type CampaignServiceGetCampaignApiArg = {
  /** The campaign id. */
  campaign: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type CampaignServiceDeleteCampaignApiResponse =
  /** status 200 OK */ string;
export type CampaignServiceDeleteCampaignApiArg = {
  /** The campaign id. */
  campaign: string;
};
export type CampaignServiceUpdateCampaignApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Campaign;
export type CampaignServiceUpdateCampaignApiArg = {
  /** The campaign id. */
  campaign: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  updateMask?: string;
  factoryEmaillabApiV1Campaign: FactoryEmaillabApiV1Campaign;
};
export type CampaignServiceHarddeleteCampaignApiResponse =
  /** status 200 OK */ string;
export type CampaignServiceHarddeleteCampaignApiArg = {
  /** The campaign id. */
  campaign: string;
  factoryEmaillabApiV1HarddeleteCampaignRequest: FactoryEmaillabApiV1HarddeleteCampaignRequest;
};
export type CampaignServiceUndeleteCampaignApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Campaign;
export type CampaignServiceUndeleteCampaignApiArg = {
  /** The campaign id. */
  campaign: string;
  factoryEmaillabApiV1UndeleteCampaignRequest: FactoryEmaillabApiV1UndeleteCampaignRequest;
};
export type CampaignServiceBatchCreateCampaignsApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchCreateCampaignsResponse;
export type CampaignServiceBatchCreateCampaignsApiArg = {
  factoryEmaillabApiV1BatchCreateCampaignsRequest: FactoryEmaillabApiV1BatchCreateCampaignsRequest;
};
export type CampaignServiceBatchGetCampaignsApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchGetCampaignsResponse;
export type CampaignServiceBatchGetCampaignsApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type CampaignServiceBatchUpdateCampaignsApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchUpdateCampaignsResponse;
export type CampaignServiceBatchUpdateCampaignsApiArg = {
  factoryEmaillabApiV1BatchUpdateCampaignsRequest: FactoryEmaillabApiV1BatchUpdateCampaignsRequest;
};
export type CampaignServiceSyncCampaignApiResponse =
  /** status 200 OK */ string;
export type CampaignServiceSyncCampaignApiArg = {
  factoryEmaillabApiV1SyncCampaignRequest: FactoryEmaillabApiV1SyncCampaignRequest;
};
export type FolderServiceListFoldersApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1ListFoldersResponse;
export type FolderServiceListFoldersApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** Should follow the Filtering best practices defined by Google AIP here https://google.aip.dev/160 */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type FolderServiceCreateFolderApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Folder;
export type FolderServiceCreateFolderApiArg = {
  factoryEmaillabApiV1Folder: FactoryEmaillabApiV1Folder;
};
export type FolderServiceGetFolderApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Folder;
export type FolderServiceGetFolderApiArg = {
  /** The folder id. */
  folder: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type FolderServiceDeleteFolderApiResponse = /** status 200 OK */ string;
export type FolderServiceDeleteFolderApiArg = {
  /** The folder id. */
  folder: string;
};
export type FolderServiceUpdateFolderApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Folder;
export type FolderServiceUpdateFolderApiArg = {
  /** The folder id. */
  folder: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  updateMask?: string;
  factoryEmaillabApiV1Folder: FactoryEmaillabApiV1Folder;
};
export type FolderServiceHarddeleteFolderApiResponse =
  /** status 200 OK */ string;
export type FolderServiceHarddeleteFolderApiArg = {
  /** The folder id. */
  folder: string;
  factoryEmaillabApiV1HarddeleteFolderRequest: FactoryEmaillabApiV1HarddeleteFolderRequest;
};
export type FolderServiceUndeleteFolderApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Folder;
export type FolderServiceUndeleteFolderApiArg = {
  /** The folder id. */
  folder: string;
  factoryEmaillabApiV1UndeleteFolderRequest: FactoryEmaillabApiV1UndeleteFolderRequest;
};
export type FolderServiceBatchCreateFoldersApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchCreateFoldersResponse;
export type FolderServiceBatchCreateFoldersApiArg = {
  factoryEmaillabApiV1BatchCreateFoldersRequest: FactoryEmaillabApiV1BatchCreateFoldersRequest;
};
export type FolderServiceBatchGetFoldersApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchGetFoldersResponse;
export type FolderServiceBatchGetFoldersApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type FolderServiceBatchUpdateFoldersApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchUpdateFoldersResponse;
export type FolderServiceBatchUpdateFoldersApiArg = {
  factoryEmaillabApiV1BatchUpdateFoldersRequest: FactoryEmaillabApiV1BatchUpdateFoldersRequest;
};
export type AuthServiceLoginTenantApiResponse = /** status 200 OK */ string;
export type AuthServiceLoginTenantApiArg = void;
export type AuthServiceLogoutTenantApiResponse = /** status 200 OK */ string;
export type AuthServiceLogoutTenantApiArg = void;
export type AuthServiceTokenTenantApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1TokenTenantResponse;
export type AuthServiceTokenTenantApiArg = {
  /** comment (for web app) */
  code?: string;
  /** comment (for web app) */
  state?: string;
  /** client id (for server to server) */
  clientId?: string;
  /** client_secret (for server to server) */
  clientSecret?: string;
  /** Account id (for server to server) */
  accountId?: number;
};
export type OauthstateServiceListOauthstatesApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1ListOauthstatesResponse;
export type OauthstateServiceListOauthstatesApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** comment */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type OauthstateServiceCreateOauthstateApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Oauthstate;
export type OauthstateServiceCreateOauthstateApiArg = {
  factoryEmaillabApiV1Oauthstate: FactoryEmaillabApiV1Oauthstate;
};
export type OauthstateServiceGetOauthstateApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Oauthstate;
export type OauthstateServiceGetOauthstateApiArg = {
  /** The oauthstate id. */
  oauthstate: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type AuthServiceListOauthtokensApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1ListOauthtokensResponse;
export type AuthServiceListOauthtokensApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** comment */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type AuthServiceCreateOauthtokenApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Oauthtoken;
export type AuthServiceCreateOauthtokenApiArg = {
  factoryEmaillabApiV1Oauthtoken: FactoryEmaillabApiV1Oauthtoken;
};
export type AuthServiceGetOauthtokenApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Oauthtoken;
export type AuthServiceGetOauthtokenApiArg = {
  /** The oauthtoken id. */
  oauthtoken: string;
  /** Comment */
  readMask?: string;
};
export type AuthServiceUpdateOauthtokenApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Oauthtoken;
export type AuthServiceUpdateOauthtokenApiArg = {
  /** The oauthtoken id. */
  oauthtoken: string;
  /** comment */
  updateMask?: string;
  factoryEmaillabApiV1Oauthtoken: FactoryEmaillabApiV1Oauthtoken;
};
export type AuthServiceHarddeleteOauthtokenApiResponse =
  /** status 200 OK */ string;
export type AuthServiceHarddeleteOauthtokenApiArg = {
  /** The oauthtoken id. */
  oauthtoken: string;
  factoryEmaillabApiV1HarddeleteOauthtokenRequest: FactoryEmaillabApiV1HarddeleteOauthtokenRequest;
};
export type ProjectServiceListProjectsApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1ListProjectsResponse;
export type ProjectServiceListProjectsApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** Should follow the Filtering best practices defined by Google AIP here https://google.aip.dev/160 */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type ProjectServiceCreateProjectApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Project;
export type ProjectServiceCreateProjectApiArg = {
  factoryEmaillabApiV1Project: FactoryEmaillabApiV1Project;
};
export type ProjectServiceGetProjectApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Project;
export type ProjectServiceGetProjectApiArg = {
  /** The project id. */
  project: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type ProjectServiceDeleteProjectApiResponse =
  /** status 200 OK */ string;
export type ProjectServiceDeleteProjectApiArg = {
  /** The project id. */
  project: string;
};
export type ProjectServiceUpdateProjectApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Project;
export type ProjectServiceUpdateProjectApiArg = {
  /** The project id. */
  project: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  updateMask?: string;
  factoryEmaillabApiV1Project: FactoryEmaillabApiV1Project;
};
export type ProjectServiceHarddeleteProjectApiResponse =
  /** status 200 OK */ string;
export type ProjectServiceHarddeleteProjectApiArg = {
  /** The project id. */
  project: string;
  factoryEmaillabApiV1HarddeleteProjectRequest: FactoryEmaillabApiV1HarddeleteProjectRequest;
};
export type ProjectServiceUndeleteProjectApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1Project;
export type ProjectServiceUndeleteProjectApiArg = {
  /** The project id. */
  project: string;
  factoryEmaillabApiV1UndeleteProjectRequest: FactoryEmaillabApiV1UndeleteProjectRequest;
};
export type ProjectServiceBatchCreateProjectsApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchCreateProjectsResponse;
export type ProjectServiceBatchCreateProjectsApiArg = {
  factoryEmaillabApiV1BatchCreateProjectsRequest: FactoryEmaillabApiV1BatchCreateProjectsRequest;
};
export type ProjectServiceBatchGetProjectsApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchGetProjectsResponse;
export type ProjectServiceBatchGetProjectsApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type ProjectServiceBatchUpdateProjectsApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchUpdateProjectsResponse;
export type ProjectServiceBatchUpdateProjectsApiArg = {
  factoryEmaillabApiV1BatchUpdateProjectsRequest: FactoryEmaillabApiV1BatchUpdateProjectsRequest;
};
export type SfmcFolderServiceListSfmcFoldersApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1ListSfmcFoldersResponse;
export type SfmcFolderServiceListSfmcFoldersApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** Should follow the Filtering best practices defined by Google AIP here https://google.aip.dev/160 */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type SfmcFolderServiceCreateSfmcFolderApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1SfmcFolder;
export type SfmcFolderServiceCreateSfmcFolderApiArg = {
  factoryEmaillabApiV1SfmcFolder: FactoryEmaillabApiV1SfmcFolder;
};
export type SfmcFolderServiceGetSfmcFolderApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1SfmcFolder;
export type SfmcFolderServiceGetSfmcFolderApiArg = {
  /** The sfmcFolder id. */
  sfmcFolder: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type SfmcFolderServiceDeleteSfmcFolderApiResponse =
  /** status 200 OK */ string;
export type SfmcFolderServiceDeleteSfmcFolderApiArg = {
  /** The sfmcFolder id. */
  sfmcFolder: string;
};
export type SfmcFolderServiceUpdateSfmcFolderApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1SfmcFolder;
export type SfmcFolderServiceUpdateSfmcFolderApiArg = {
  /** The sfmcFolder id. */
  sfmcFolder: string;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  updateMask?: string;
  factoryEmaillabApiV1SfmcFolder: FactoryEmaillabApiV1SfmcFolder;
};
export type SfmcFolderServiceHarddeleteSfmcFolderApiResponse =
  /** status 200 OK */ string;
export type SfmcFolderServiceHarddeleteSfmcFolderApiArg = {
  /** The sfmcFolder id. */
  sfmcFolder: string;
  factoryEmaillabApiV1HarddeleteSfmcFolderRequest: FactoryEmaillabApiV1HarddeleteSfmcFolderRequest;
};
export type SfmcFolderServiceUndeleteSfmcFolderApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1SfmcFolder;
export type SfmcFolderServiceUndeleteSfmcFolderApiArg = {
  /** The sfmcFolder id. */
  sfmcFolder: string;
  factoryEmaillabApiV1UndeleteSfmcFolderRequest: FactoryEmaillabApiV1UndeleteSfmcFolderRequest;
};
export type SfmcFolderServiceBatchCreateSfmcFoldersApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchCreateSfmcFoldersResponse;
export type SfmcFolderServiceBatchCreateSfmcFoldersApiArg = {
  factoryEmaillabApiV1BatchCreateSfmcFoldersRequest: FactoryEmaillabApiV1BatchCreateSfmcFoldersRequest;
};
export type SfmcFolderServiceBatchGetSfmcFoldersApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchGetSfmcFoldersResponse;
export type SfmcFolderServiceBatchGetSfmcFoldersApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type SfmcFolderServiceBatchUpdateSfmcFoldersApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchUpdateSfmcFoldersResponse;
export type SfmcFolderServiceBatchUpdateSfmcFoldersApiArg = {
  factoryEmaillabApiV1BatchUpdateSfmcFoldersRequest: FactoryEmaillabApiV1BatchUpdateSfmcFoldersRequest;
};
export type UserServiceListUsersApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1ListUsersResponse;
export type UserServiceListUsersApiArg = {
  /** comment */
  pageSize?: number;
  /** comment */
  pageNumber?: number;
  /** comment */
  filter?: string;
  /** comment */
  orderBy?: string;
  /** comment */
  showDeleted?: boolean;
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type UserServiceCreateUserApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1User;
export type UserServiceCreateUserApiArg = {
  factoryEmaillabApiV1User: FactoryEmaillabApiV1User;
};
export type UserServiceGetUserApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1User;
export type UserServiceGetUserApiArg = {
  /** The user id. */
  user: string;
  /** Specified which part of the User should be returned */
  readMask?: string;
};
export type UserServiceDeleteUserApiResponse = /** status 200 OK */ string;
export type UserServiceDeleteUserApiArg = {
  /** The user id. */
  user: string;
};
export type UserServiceUpdateUserApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1User;
export type UserServiceUpdateUserApiArg = {
  /** The user id. */
  user: string;
  /** comment */
  updateMask?: string;
  factoryEmaillabApiV1User: FactoryEmaillabApiV1User;
};
export type UserServiceBatchGetUsersApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1BatchGetUsersResponse;
export type UserServiceBatchGetUsersApiArg = {
  /** The names of the books to retrieve. A maximum of 1000 books can be retrieved in a batch. Format: publishers/{publisher}/books/{book} */
  names?: string[];
  /** Should follow the Field masks best practices defined by Google AIP here https://google.aip.dev/161 */
  readMask?: string;
};
export type UserServiceSearchUserApiResponse =
  /** status 200 OK */ FactoryEmaillabApiV1User;
export type UserServiceSearchUserApiArg = {
  /** Comment */
  key?: string;
  /** Comment */
  value?: string;
};
export type FactoryEmaillabApiV1Meta = {
  create_time?: string;
  creation_user?: string;
  update_time?: string;
  update_user?: string;
  delete_time?: string;
  deletion_user?: string;
  sfmc_mid?: number;
  resource_name?: string;
  operation_name?: string;
};
export type FactoryEmaillabApiV1Campaign = {
  name?: string;
  display_name: string;
  preview_path?: string;
  html?: string;
  medias?: {
    [key: string]: string;
  };
  meta?: FactoryEmaillabApiV1Meta;
};
export type FactoryEmaillabApiV1ListCampaignsResponse = {
  campaigns?: FactoryEmaillabApiV1Campaign[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type GoogleProtobufAny = {
  '@type'?: string;
  [key: string]: any;
};
export type GoogleRpcStatus = {
  code?: number;
  message?: string;
  details?: GoogleProtobufAny[];
};
export type FactoryEmaillabApiV1HarddeleteCampaignRequest = {
  name: string;
};
export type FactoryEmaillabApiV1UndeleteCampaignRequest = {
  name: string;
};
export type FactoryEmaillabApiV1BatchCreateCampaignsResponse = {
  campaigns?: FactoryEmaillabApiV1Campaign[];
};
export type FactoryEmaillabApiV1CreateCampaignRequest = {
  campaign: FactoryEmaillabApiV1Campaign;
};
export type FactoryEmaillabApiV1BatchCreateCampaignsRequest = {
  requests: FactoryEmaillabApiV1CreateCampaignRequest[];
};
export type FactoryEmaillabApiV1BatchGetCampaignsResponse = {
  campaigns?: FactoryEmaillabApiV1Campaign[];
};
export type FactoryEmaillabApiV1BatchUpdateCampaignsResponse = {
  campaigns?: FactoryEmaillabApiV1Campaign[];
};
export type FactoryEmaillabApiV1UpdateCampaignRequest = {
  campaign: FactoryEmaillabApiV1Campaign;
  update_mask?: string;
};
export type FactoryEmaillabApiV1BatchUpdateCampaignsRequest = {
  requests: FactoryEmaillabApiV1UpdateCampaignRequest[];
};
export type FactoryEmaillabApiV1SyncCampaignRequest = {
  campaign: string;
  name?: string;
  category_id?: number;
};
export type FactoryEmaillabApiV1Folder = {
  name?: string;
  display_name: string;
  folders?: FactoryEmaillabApiV1Folder[];
  campaigns?: FactoryEmaillabApiV1Campaign[];
  meta?: FactoryEmaillabApiV1Meta;
};
export type FactoryEmaillabApiV1ListFoldersResponse = {
  folders?: FactoryEmaillabApiV1Folder[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryEmaillabApiV1HarddeleteFolderRequest = {
  name: string;
};
export type FactoryEmaillabApiV1UndeleteFolderRequest = {
  name: string;
};
export type FactoryEmaillabApiV1BatchCreateFoldersResponse = {
  folders?: FactoryEmaillabApiV1Folder[];
};
export type FactoryEmaillabApiV1CreateFolderRequest = {
  folder: FactoryEmaillabApiV1Folder;
};
export type FactoryEmaillabApiV1BatchCreateFoldersRequest = {
  requests: FactoryEmaillabApiV1CreateFolderRequest[];
};
export type FactoryEmaillabApiV1BatchGetFoldersResponse = {
  folders?: FactoryEmaillabApiV1Folder[];
};
export type FactoryEmaillabApiV1BatchUpdateFoldersResponse = {
  folders?: FactoryEmaillabApiV1Folder[];
};
export type FactoryEmaillabApiV1UpdateFolderRequest = {
  folder: FactoryEmaillabApiV1Folder;
  update_mask?: string;
};
export type FactoryEmaillabApiV1BatchUpdateFoldersRequest = {
  requests: FactoryEmaillabApiV1UpdateFolderRequest[];
};
export type FactoryEmaillabApiV1TokenTenantResponse = {
  token?: string;
};
export type FactoryEmaillabApiV1Oauthstate = {
  name?: string;
  state?: string;
  meta?: FactoryEmaillabApiV1Meta;
};
export type FactoryEmaillabApiV1ListOauthstatesResponse = {
  oauthstates?: FactoryEmaillabApiV1Oauthstate[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryEmaillabApiV1Oauthtoken = {
  name?: string;
  oauthtoken?: string;
  meta?: FactoryEmaillabApiV1Meta;
};
export type FactoryEmaillabApiV1ListOauthtokensResponse = {
  oauthtokens?: FactoryEmaillabApiV1Oauthtoken[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryEmaillabApiV1HarddeleteOauthtokenRequest = {
  name: string;
};
export type GoogleProtobufFloatValue = {
  value?: number;
};
export type GoogleTypeColor = {
  red?: number;
  green?: number;
  blue?: number;
  alpha?: GoogleProtobufFloatValue;
};
export type FactoryEmaillabApiV1Project = {
  name?: string;
  display_name: string;
  common?: boolean;
  color?: GoogleTypeColor;
  meta?: FactoryEmaillabApiV1Meta;
};
export type FactoryEmaillabApiV1ListProjectsResponse = {
  projects?: FactoryEmaillabApiV1Project[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryEmaillabApiV1HarddeleteProjectRequest = {
  name: string;
};
export type FactoryEmaillabApiV1UndeleteProjectRequest = {
  name: string;
};
export type FactoryEmaillabApiV1BatchCreateProjectsResponse = {
  projects?: FactoryEmaillabApiV1Project[];
};
export type FactoryEmaillabApiV1CreateProjectRequest = {
  project: FactoryEmaillabApiV1Project;
};
export type FactoryEmaillabApiV1BatchCreateProjectsRequest = {
  requests: FactoryEmaillabApiV1CreateProjectRequest[];
};
export type FactoryEmaillabApiV1BatchGetProjectsResponse = {
  projects?: FactoryEmaillabApiV1Project[];
};
export type FactoryEmaillabApiV1BatchUpdateProjectsResponse = {
  projects?: FactoryEmaillabApiV1Project[];
};
export type FactoryEmaillabApiV1UpdateProjectRequest = {
  project: FactoryEmaillabApiV1Project;
  update_mask?: string;
};
export type FactoryEmaillabApiV1BatchUpdateProjectsRequest = {
  requests: FactoryEmaillabApiV1UpdateProjectRequest[];
};
export type FactoryEmaillabApiV1SfmcFolder = {
  name?: string;
  display_name?: string;
  parent_id?: number;
  category_type?: string;
  member_id?: number;
  enterprise_id?: number;
  id?: number;
  meta?: FactoryEmaillabApiV1Meta;
};
export type FactoryEmaillabApiV1ListSfmcFoldersResponse = {
  sfmc_folder?: FactoryEmaillabApiV1SfmcFolder[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryEmaillabApiV1HarddeleteSfmcFolderRequest = {
  name: string;
};
export type FactoryEmaillabApiV1UndeleteSfmcFolderRequest = {
  name: string;
};
export type FactoryEmaillabApiV1BatchCreateSfmcFoldersResponse = {
  sfmc_folders?: FactoryEmaillabApiV1SfmcFolder[];
};
export type FactoryEmaillabApiV1CreateSfmcFolderRequest = {
  sfmc_folder: FactoryEmaillabApiV1SfmcFolder;
};
export type FactoryEmaillabApiV1BatchCreateSfmcFoldersRequest = {
  requests: FactoryEmaillabApiV1CreateSfmcFolderRequest[];
};
export type FactoryEmaillabApiV1BatchGetSfmcFoldersResponse = {
  sfmc_folders?: FactoryEmaillabApiV1SfmcFolder[];
};
export type FactoryEmaillabApiV1BatchUpdateSfmcFoldersResponse = {
  sfmc_folders?: FactoryEmaillabApiV1SfmcFolder[];
};
export type FactoryEmaillabApiV1UpdateSfmcFolderRequest = {
  sfmc_folder: FactoryEmaillabApiV1SfmcFolder;
  update_mask?: string;
};
export type FactoryEmaillabApiV1BatchUpdateSfmcFoldersRequest = {
  requests: FactoryEmaillabApiV1UpdateSfmcFolderRequest[];
};
export type FactoryEmaillabApiV1User = {
  name?: string;
  display_name?: string;
  username?: string;
  key?: string;
  email?: string;
  locale?: string;
  zoneinfo?: string;
  mid?: number;
  eid?: number;
  entreprise?: string;
  oauth2?: FactoryEmaillabApiV1Oauthtoken;
  collection_data_table_ui?: string[];
  map_data_table_ui?: string[];
  toggle_welcome_modal?: boolean;
  role?: 'ROLE_UNSPECIFIED' | 'CONTRIBUTOR' | 'REVIEWER' | 'ADMIN';
  avatar?: string;
  stack_key?: string;
  api_user?: boolean;
  meta?: FactoryEmaillabApiV1Meta;
};
export type FactoryEmaillabApiV1ListUsersResponse = {
  users?: FactoryEmaillabApiV1User[];
  page_number?: number;
  page_size?: number;
  total_count?: number;
};
export type FactoryEmaillabApiV1BatchGetUsersResponse = {
  users?: FactoryEmaillabApiV1User[];
};
export const {
  useCampaignServiceListCampaignsQuery,
  useLazyCampaignServiceListCampaignsQuery,
  useCampaignServiceCreateCampaignMutation,
  useCampaignServiceGetCampaignQuery,
  useLazyCampaignServiceGetCampaignQuery,
  useCampaignServiceDeleteCampaignMutation,
  useCampaignServiceUpdateCampaignMutation,
  useCampaignServiceHarddeleteCampaignMutation,
  useCampaignServiceUndeleteCampaignMutation,
  useCampaignServiceBatchCreateCampaignsMutation,
  useCampaignServiceBatchGetCampaignsQuery,
  useLazyCampaignServiceBatchGetCampaignsQuery,
  useCampaignServiceBatchUpdateCampaignsMutation,
  useCampaignServiceSyncCampaignMutation,
  useFolderServiceListFoldersQuery,
  useLazyFolderServiceListFoldersQuery,
  useFolderServiceCreateFolderMutation,
  useFolderServiceGetFolderQuery,
  useLazyFolderServiceGetFolderQuery,
  useFolderServiceDeleteFolderMutation,
  useFolderServiceUpdateFolderMutation,
  useFolderServiceHarddeleteFolderMutation,
  useFolderServiceUndeleteFolderMutation,
  useFolderServiceBatchCreateFoldersMutation,
  useFolderServiceBatchGetFoldersQuery,
  useLazyFolderServiceBatchGetFoldersQuery,
  useFolderServiceBatchUpdateFoldersMutation,
  useAuthServiceLoginTenantQuery,
  useLazyAuthServiceLoginTenantQuery,
  useAuthServiceLogoutTenantQuery,
  useLazyAuthServiceLogoutTenantQuery,
  useAuthServiceTokenTenantQuery,
  useLazyAuthServiceTokenTenantQuery,
  useOauthstateServiceListOauthstatesQuery,
  useLazyOauthstateServiceListOauthstatesQuery,
  useOauthstateServiceCreateOauthstateMutation,
  useOauthstateServiceGetOauthstateQuery,
  useLazyOauthstateServiceGetOauthstateQuery,
  useAuthServiceListOauthtokensQuery,
  useLazyAuthServiceListOauthtokensQuery,
  useAuthServiceCreateOauthtokenMutation,
  useAuthServiceGetOauthtokenQuery,
  useLazyAuthServiceGetOauthtokenQuery,
  useAuthServiceUpdateOauthtokenMutation,
  useAuthServiceHarddeleteOauthtokenMutation,
  useProjectServiceListProjectsQuery,
  useLazyProjectServiceListProjectsQuery,
  useProjectServiceCreateProjectMutation,
  useProjectServiceGetProjectQuery,
  useLazyProjectServiceGetProjectQuery,
  useProjectServiceDeleteProjectMutation,
  useProjectServiceUpdateProjectMutation,
  useProjectServiceHarddeleteProjectMutation,
  useProjectServiceUndeleteProjectMutation,
  useProjectServiceBatchCreateProjectsMutation,
  useProjectServiceBatchGetProjectsQuery,
  useLazyProjectServiceBatchGetProjectsQuery,
  useProjectServiceBatchUpdateProjectsMutation,
  useSfmcFolderServiceListSfmcFoldersQuery,
  useLazySfmcFolderServiceListSfmcFoldersQuery,
  useSfmcFolderServiceCreateSfmcFolderMutation,
  useSfmcFolderServiceGetSfmcFolderQuery,
  useLazySfmcFolderServiceGetSfmcFolderQuery,
  useSfmcFolderServiceDeleteSfmcFolderMutation,
  useSfmcFolderServiceUpdateSfmcFolderMutation,
  useSfmcFolderServiceHarddeleteSfmcFolderMutation,
  useSfmcFolderServiceUndeleteSfmcFolderMutation,
  useSfmcFolderServiceBatchCreateSfmcFoldersMutation,
  useSfmcFolderServiceBatchGetSfmcFoldersQuery,
  useLazySfmcFolderServiceBatchGetSfmcFoldersQuery,
  useSfmcFolderServiceBatchUpdateSfmcFoldersMutation,
  useUserServiceListUsersQuery,
  useLazyUserServiceListUsersQuery,
  useUserServiceCreateUserMutation,
  useUserServiceGetUserQuery,
  useLazyUserServiceGetUserQuery,
  useUserServiceDeleteUserMutation,
  useUserServiceUpdateUserMutation,
  useUserServiceBatchGetUsersQuery,
  useLazyUserServiceBatchGetUsersQuery,
  useUserServiceSearchUserQuery,
  useLazyUserServiceSearchUserQuery
} = injectedRtkApi;
